import {Button, showNotification} from 'platform/components';
import styled from 'styled-components';

import {useState} from 'react';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {
  SimpleTable,
  DataType,
  TypographyCard,
  useRouter,
  BillingInformationService,
  BillingInformationListItem,
  useCallApi,
} from '@dms/teas';

import {composePath, useNavigate} from 'shared/web';

export const BillingInformationList = () => {
  const router = useRouter();
  const navigate = useNavigate();
  const [listItems, setListItems] = useState<BillingInformationListItem[]>([]);
  const getBillingInformationList = useCallApi(BillingInformationService.getBillingInformationList);

  !listItems.length &&
    getBillingInformationList()
      .then((result) => {
        setListItems(result.billingInformationListItems ?? []);
      })
      .catch((error: Error & {response?: {data?: {error?: {message?: string}}}}) => {
        showNotification.error(error.response?.data?.error?.message || error.toString());
      });

  const columns = [
    {
      Header: i18n.t('entity.customer.labels.billingName'),
      id: 'billingName',
    },
    {
      Header: i18n.t('entity.customer.labels.companyName'),
      id: 'companyName',
    },
    {
      Header: i18n.t('entity.address.labels.city'),
      id: 'city',
    },
    {
      Header: i18n.t('entity.address.labels.street'),
      id: 'street',
    },
    {
      Header: i18n.t('entity.customer.labels.registrationNumber'),
      id: 'registrationNumber',
    },
    {
      Header: null,
      id: 'action',
    },
  ];

  const createRow = (item: BillingInformationListItem): DataType => ({
    id: item.id,
    billingName: item.billingName || '-',
    companyName: item.companyName || '-',
    city: item.city || '-',
    street: item.street || '-',
    registrationNumber: item.registrationNumber || '-',
  });

  return (
    <>
      <ListCardStyled
        title={i18n.t('entity.customer.labels.billingInformation')}
        headerContent={
          <Button
            variant="link"
            leftIcon="content/add_circle"
            data-testid={testIds.settings.billingInformation('createNew')}
            title={i18n.t('entity.customer.actions.addBillingInformation')}
            onClick={() => {
              navigate(settingsRoutes.billingInformationNew);
            }}
          />
        }
      >
        <SimpleTable
          noZebra
          showRowDivider
          highlightRowOnHover
          tdPadding="default"
          columns={columns}
          rows={[{data: listItems?.map(createRow) || []}]}
          data-testid={testIds.settings.billingInformation('table')}
          onRowClick={(row) =>
            router.push(
              composePath(settingsRoutes.billingInformationEdit, {
                params: {id: row.id as string},
              })
            )
          }
        />
      </ListCardStyled>
    </>
  );
};

export const ListCardStyled = styled(TypographyCard)`
  .card-content {
    padding: 0;
  }
`;
